import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { REPORT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { ZonalStatementPage } from '@/features/zonalStatement/pages/ZonalStatementPage';
import { zonalStatementListSearchSchema } from '@/features/zonalStatement/types/zonalStatement.types';

export const Route = createFileRoute('/_auth/dashboards/zonal-statement/')({
  beforeLoad: () => requirePermission(REPORT_PERMISSIONS.ZONAL_STATEMENT_VIEW),
  validateSearch: zonalStatementListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Specimen Closing">
      <Suspense fallback={<PageLoader />}>
        <ZonalStatementPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
